import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import * as StockSelectors from 'selectors/StockSelectors';
import * as ShopSelectors from 'selectors/ShopSelectors';
import Container from 'common/components/Container';
import RentlePayments from './RentlePayments';
import ThirdPartyProviders from './ThirdPartyProviders';
import Manual from './Manual';
import { StartAcceptingPaymentsBanner } from './components/StartAcceptingPaymentsBanner';
import HasFeature from 'components/features/HasFeature';
import POS from './POS';
import { isDepositPaymentMethod } from 'common/modules/payments/paymentMethods';
import { NoDepositSupportBanner } from './components/NoDepositSupportBanner';
import { ADYEN_HOP_COUNTRY_CODES } from 'common/constants/countries';
import { mapPaymentTerritoryToCountry } from 'common/modules/payments/utils';

const Payments = () => {
	const classes = useStyles();
	const selectedPaymentMethods = useSelector(ShopSelectors.getActivePaymentMethods);
	const shop = useSelector(ShopSelectors.activeShopData)!;
	const { country: shopCountry } = shop.publicInfo;
	const shopCountrySupportedByRentlePayments =
		!!shopCountry &&
		ADYEN_HOP_COUNTRY_CODES.some((code) => code === mapPaymentTerritoryToCountry(shopCountry));

	const noDepositPaymentMethodInUse = !selectedPaymentMethods
		.map((m) => m.id)
		.some(isDepositPaymentMethod);
	const hasDepositProducts = useSelector(StockSelectors.hasDepositProducts);
	const showStartAcceptingPaymentsBanner = !selectedPaymentMethods.length;
	const showNoDepositSupportBanner =
		!!selectedPaymentMethods.length && noDepositPaymentMethodInUse && hasDepositProducts;

	return (
		<Container>
			<Box mb={4} className={classes.bannerContainer}>
				{showStartAcceptingPaymentsBanner ? (
					<StartAcceptingPaymentsBanner />
				) : showNoDepositSupportBanner ? (
					<NoDepositSupportBanner />
				) : null}
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: shopCountrySupportedByRentlePayments ? 'column' : 'column-reverse',
				}}
			>
				<RentlePayments isSupported={shopCountrySupportedByRentlePayments} />
				<ThirdPartyProviders rentlePaymentsSupported={shopCountrySupportedByRentlePayments} />
			</Box>
			<Manual />
			<HasFeature requiredFeature="POS">
				<POS />
			</HasFeature>
		</Container>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		bannerContainer: {
			'&:empty': {
				display: 'none',
			},
		},
	}),
);

export default Payments;
